import React, { FC, useCallback } from 'react';
import { Tag } from 'antd';
import { TagFilled } from '@ant-design/icons';

export interface IEachFilterPill {
	displayText: string;
	fieldName: string;
	value: string;
	type: string;
	notClosable?: boolean;
	onClick?: () => void;
	clearFilter: (fieldName: string, value: string, type: string) => void;
	color?: any;
	style?: any;
	labelColor?: string;
}

const EachFilterPill: FC<IEachFilterPill> = ({
	displayText,
	fieldName,
	value,
	type,
	clearFilter,
	onClick,
	notClosable,
	color,
	style,
	labelColor,
}): React.ReactElement => {
	const onClearFilter = useCallback(
		() => clearFilter(fieldName, value, type),
		[fieldName, value, type, clearFilter]
	);

	const onPillClick = useCallback(
		() => notClosable && onClick && onClick(),
		[notClosable, onClick]
	);

	return (
		<Tag
			color={color}
			closable={!notClosable}
			onClose={onClearFilter}
			icon={labelColor ? <TagFilled style={{ color: labelColor }} /> : undefined}
			style={{ fontSize: '14px', padding: '4px 12px', ...style }}
			onClick={onPillClick}
		>
			{displayText}
		</Tag>
	);
};

export default EachFilterPill;
